import { useEffect, useRef, useState } from 'react';
import ImagenBannerIMMSA from '../../assets/images/IMMSA.jpg';
import './IMMSA.css';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Telefono from '../../assets/images/Telefono.png';
import Ubi from '../../assets/images/Ubi.png';
import Email34 from '../../assets/images/Correo.png';
import RedesFondo from '../../assets/images/Red-Neuronal.png';
import checkAnim from '../../assets/images/check.gif';

function IMMSA() {

    
  return (
    <>
    {/* Bloque de inicio de caso IMMSA */}
    <div className="infra-banner-IMMSA">
      {/* Imagen inicio de caso IMMSA */}
  <img src={ImagenBannerIMMSA} alt="IMMSA" className="banner-img-IMMSA" />
  {/*Titulo de caso IMMSA Inicio  */}
    <h1 className="banner-texto-IMMSA">IMMSA</h1>
</div>
{/* Bloque de inicio info de caso IMMSA */}
<div className="fondo-blanco">
<div className="contenedor-immsa">
  <div className="columna-izquierda">
    {/* Bloque Izquierdo de caso IMMSA */}
    <h1>SECTOR:</h1>
    <p>METALMECANICO</p>
    <h1>PAIS:</h1>
    <p>MÉXICO</p>
    <h1>EMPRESA:</h1>
     <p> International Metals de México es una empresa mexicana líder en la fabricación de componentes metálicos especializados en cobre y aluminio, como busbars, bujes y conectores, dirigidos a las industrias eléctrica, de datos y de movilidad.<br>
      </br>
      <br></br>

      Cuenta con tres instalaciones estratégicamente ubicadas a lo largo del corredor comercial USMCA, lo que les permite operar con eficiencia logística y cobertura en América del Norte.
    </p>
    <div className="boton-reto">
      <a href="https://www.immsa.mx/" className="btn-reto">Visita su sitio web</a>
    </div>
  </div>

  <div className="columna-derecha">
    {/* Bloque Derecho de caso IMMSA */}
    <h2>RETO DEL PROYECTO: FORTALECIMIENTO DEL CONTROL FINANCIERO EN IMMSA</h2>
    <p>Como resultado del crecimiento acelerado de IMMSA, la organización enfrenta el desafío de consolidar un sistema de control financiero más robusto y eficiente. Este reto implica la redefinición del plan contable y del modelo de costos, así como la reestructuración integral de los procesos contables que respaldan sus operaciones administrativas y de producción. El proyecto busca garantizar que la información financiera refleje con precisión el dinamismo empresarial, facilitando la toma de decisiones estratégicas en un entorno de expansión.</p>

    <h2>SOLUCIÓN IMPLEMENTADA: OPTIMIZACIÓN DEL SISTEMA CONTABLE EN IMMSA</h2>
    <p>Como parte de nuestra asesoría especializada, se llevó a cabo un análisis exhaustivo de las operaciones contables integradas al sistema ERP de IMMSA. El objetivo fue asegurar la alineación del flujo operativo con el nuevo plan contable y de costos, derivado de su reciente expansión.
A partir del diagnóstico, se diseñó e implementó una estructura contable renovada que responde eficazmente a las necesidades de información financiera requeridas por la alta dirección. Esta nueva configuración permitió:<br></br>
<br></br>
•	Integrar el plan contable y de costos a la lógica operativa del ERP.<br></br>
•	Optimizar los procesos contables internos.<br></br>
•	Reducir el tiempo de entrega de los estados financieros mensuales.<br></br>
•	Mejorar la calidad y oportunidad de los reportes hacia la dirección.<br>
</br> <br></br>
Gracias a esta solución, IMMSA cuenta hoy con un modelo contable más ágil, preciso y alineado a su estrategia empresarial.
</p>

    <h2>RESEÑA</h2>
    <p>Pendiente.</p>
  </div>
</div>
</div>

{/* Contenedor principal  de pie de página con contacto*/}

<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        <li><a href="/">• IAutomatiza CFDI</a></li>
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Sistemas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        <li><a href="/CasosExito">Ver Mas Casos de Éxito</a></li>
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>

</>
  );
}

export default IMMSA;